import styled from 'styled-components';

// colors
import {grey} from '@drivesally/sally-ui/lib/libs/colors';

const Controls = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 5px;
  border: 1px solid ${grey};
  border-radius: 4px;
`;

export default Controls;
